module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Medium-1317d82ebb5c11e4dfc17626ee3ff56f.otf";